import React, { useCallback, useEffect, useState } from 'react'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import { SelectionOption } from 'components/SearchV2/Components/FilterPanel/FilterPanel'
import { HolidayTypeToIconMap, getTopNFilterOptions } from 'lib/searchUtils'
import { connect } from 'react-redux'
import { getValueByCaseInsensitiveKey } from 'lib/objectUtils'
import { getOfferListKeySelector } from 'selectors/offerSelectors'
import SelectionTile from 'components/Common/SelectionTile'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/client/store'
import { replace } from 'connected-react-router'
import { deleteSearchParams, setSearchParamValue } from 'lib/urlUtils'
import styled from 'styled-components'
import { rem } from 'polished'

const StyledSelectionTile = styled(SelectionTile)`
  padding: ${rem(12)} ${rem(20)};
  min-width: ${rem(72)};
  white-space: nowrap;
`

interface Props {
  filters: App.OfferListFilters;
  search: string;
  onFilterClick?: () => void;
}

interface MappedStateProps {
  availableFilters: App.OfferListFilterOptions;
}

function AnywhereFilterTabs(props: Props & MappedStateProps) {
  const { filters, availableFilters, search, onFilterClick } = props
  const [currentTab, setCurrentTab] = useState<string>(filters.holidayTypes?.[0] ?? 'All')
  const [availableFiltersInState, setAvailableFiltersInState] = useState<App.OfferListFilterOptions | null>(null)

  useEffect(() => {
    if (availableFilters !== undefined) {
      setAvailableFiltersInState(availableFilters)
    }
  }, [availableFilters])

  const dispatch = useDispatch<AppDispatch>()

  const onSelect = useCallback((selectionId: string) => {
    if (onFilterClick) {
      onFilterClick()
    }
    if (currentTab === selectionId || selectionId === 'All') {
      setCurrentTab('All')
      dispatch(
        replace({
          search: deleteSearchParams(
            search,
            'holidayTypes',
          ),
        }),
      )
    } else {
      setCurrentTab(selectionId)
      dispatch(
        replace({
          search: setSearchParamValue(
            search,
            'holidayTypes',
            selectionId,
          ),
        }),
      )
    }
  }, [currentTab, dispatch, onFilterClick, search])

  const availableHolidayTypeFilters = availableFiltersInState?.filters?.holidayTypes

  const topHolidayTypes = getTopNFilterOptions(availableHolidayTypeFilters, availableFiltersInState?.filterOrder?.holidayTypes, 30)

  if (!topHolidayTypes) {
    return null
  }

  const topHolidayTypeOptions = topHolidayTypes.map<SelectionOption>(
    ([holidayType]) => {
      const icon = getValueByCaseInsensitiveKey(
        HolidayTypeToIconMap,
        holidayType,
      )
      return {
        icon: icon ?? HolidayTypeToIconMap.Default,
        text: holidayType,
        id: `${holidayType}-theme`,
      }
    },
  )

  const themeOptions: SelectionOption[] = [{
    icon: HolidayTypeToIconMap.All,
    text: 'All',
    id: 'All-theme',
  }]

  const options = themeOptions.concat(topHolidayTypeOptions)

  return (
    <CardCarousel gap={0}>
      {
        options.map((option) => (
          <StyledSelectionTile key={option.id} titleText={option.text} selectionId={option.text} icon={option.icon} isActive={currentTab === option.text} isTab onSelect={onSelect} />
        ))
      }
    </CardCarousel>
  )
}

export default connect<MappedStateProps, undefined, Props, App.State>((appState, ownProps) => {
  const offerListKey = getOfferListKeySelector(appState, ownProps)
  return {
    availableFilters: appState.offer.offerListFilterOptions[offerListKey],
  }
})(AnywhereFilterTabs)
